import React from 'react';
import { Modal, Button } from 'react-bootstrap-v5';
import { useIntl } from 'react-intl';
import './NpsSurveyModal.css';

interface NpsSurveyModalProps {
  show: boolean;
  onScoreClick: (score: number) => void;
  onDismiss: () => void;
  npsQuestion?: string | null;
}

export const NpsSurveyModal: React.FC<NpsSurveyModalProps> = ({
  show,
  onScoreClick,
  onDismiss,
  npsQuestion,
}) => {
  const intl = useIntl();

  const scores = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10];

  // Função para determinar a classe CSS baseada no score (seguindo padrão do NPS web)
  const getScoreClass = (score: number) => {
    if (score <= 6) return 'nps-score-detractor'; // Vermelho
    if (score <= 8) return 'nps-score-passive'; // Amarelo
    return 'nps-score-promoter'; // Verde
  };

  return (
    <Modal show={show} onHide={onDismiss} centered size="lg">
      <Modal.Header>
        <Modal.Title>
          {intl.formatMessage({
            id: 'nps.modal.title',
            defaultMessage: 'Como você avalia nossa plataforma?',
          })}
        </Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <div className="text-center mb-6">
          <p className="fs-5 text-gray-700 mb-8">
            {npsQuestion || intl.formatMessage({
              id: 'nps.modal.question',
              defaultMessage:
                'Em uma escala de 0 a 10, o quanto você recomendaria a Konfidency para um colega ou amigo?',
            })}
          </p>

          {/* Seletor de notas */}
          <div className="d-flex justify-content-center gap-2 flex-wrap mb-4">
            {scores.map((score) => (
              <button
                key={score}
                onClick={() => onScoreClick(score)}
                className={`btn ${getScoreClass(score)}`}
                style={{
                  minWidth: '33px',
                  height: '33px',
                  padding: '0',
                  fontSize: '15px',
                  borderRadius: '5px',
                  lineHeight: '31px'
                }}
              >
                {score}
              </button>
            ))}
          </div>

          {/* Labels */}
          <div className="d-flex justify-content-between text-muted fs-7 mt-2">
            <span>
              {intl.formatMessage({
                id: 'nps.modal.not-likely',
                defaultMessage: 'Nada provável',
              })}
            </span>
            <span>
              {intl.formatMessage({
                id: 'nps.modal.very-likely',
                defaultMessage: 'Muito provável',
              })}
            </span>
          </div>
        </div>
      </Modal.Body>

      <Modal.Footer className="justify-content-center">
        <Button variant="light" onClick={onDismiss}>
          {intl.formatMessage({
            id: 'nps.modal.later',
            defaultMessage: 'Agora não',
          })}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};
